import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取船名列表
export function getVesselList() {
  return request({
    url: URL.mdm.getVesselList,
    method: 'get'
  })
}

// 获取当前船公司的EDI
export function getEDICode(params) {
  return request({
    url: URL.mdm.getEDICode,
    method: 'get',
    params
  })
}

// 船名对应船公司
export function getVesselCarriers(params) {
  return request({
    url: URL.mdm.getVesselCarriers,
    method: 'get',
    params
  })
}

// 获取航次列表(根据船名ID)
export function getVoyagesByVesselId(params) {
  return request({
    url: URL.mdm.getVoyagesByVesselId,
    method: 'get',
    params
  })
}
// 船名航次-保存船名
export function saveVessel(data) {
  return request({
    url: URL.mdm.saveVessel,
    method: 'post',
    data
  })
}
// 船名航次-保存船名
export function delVessel(params) {
  return request({
    url: URL.mdm.delVessel,
    method: 'get',
    params
  })
}
